import { Stack } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import GeneralSettings from "./GeneralSettings";
import GroupSettings from "./GroupSettings";
import MeasureSettings from "./MeasureSettings";

interface Props {
  isApiReport: boolean;
  readonlyMode: boolean;
}
export default function SettingsContainer({ isApiReport, readonlyMode }: Props) {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={2} useFlexGap sx={{ px: "1.3rem", width: "100%" }}>
        <GeneralSettings isApiReport={isApiReport} readonlyMode={readonlyMode} />
        <GroupSettings readonlyMode={readonlyMode} />
        <MeasureSettings readonlyMode={readonlyMode} title="Measure Columns" />
      </Stack>
    </ScrollableFlexContainer>
  );
}
